import localScaleManager from "../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../helpers/tweensConfigs";

export default class LockScreen {
  constructor(scene, depthToBeAdded) {
    this.scene = scene;
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    this.overlay.setAlpha(0);
    this.overlay.setDepth(500 + depthToBeAdded);
    this.overlay.setInteractive();

    this.text = "";
    this.text = this.text.padStart(20, "a");
    this.textObj = this.scene.add
      .bitmapText(0, 0, "HelveticaNeue", this.text)
      .setDepth(this.overlay.depth + 1);
    this.textObj.setData("width", this.textObj.width);
    this.textObj.setData("height", this.textObj.height);
  }
  /**
   * @param text {string}
   */
  updateText(text) {
    this.text = text;
    this.textObj.setText(text);
    this.textObj.setX(
      this.overlay.x + (this.overlay.width - this.textObj.width) / 2
    );
  }
  /**
   * @param msg {string}
   */
  show(msg = "") {
    this.positionControls();
    this.updateText(msg);
    this.scene.changeObjectsInteractivity(false);
    if (!this.textObj.visible) this.textObj.setVisible(true);
    this.scene.tweens.add({
      targets: this.overlay,
      duration: tweenConfigs.lockScreen.show.duration,
      ease: tweenConfigs.lockScreen.show.ease,
      alpha: 1,
    });
  }
  hide() {
    this.scene.changeObjectsInteractivity(true);
    if (this.textObj.visible) this.textObj.setVisible(false);
    this.scene.tweens.add({
      targets: this.overlay,
      duration: tweenConfigs.lockScreen.hide.duration,
      ease: tweenConfigs.lockScreen.hide.ease,
      alpha: 0,
    });
  }
  positionControls() {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    const visitedTableGameIndex = this.scene.getVisitedTableGameIndex();
    if (visitedTableGameIndex !== -1)
      this.overlay.setX(visitedTableGameIndex * this.overlay.width);
    else this.overlay.setPosition(0, 0);
    // this.overlay.setPosition(this.scene.gameWidth / 2, this.scene.gameHeight / 2)

    this.textSize = this.overlay.width / 2;
    localScaleManager.scaleBitMapText(
      this.textObj,
      this.textSize,
      this.overlay.height / 2,
      0,
      1,
      false
    );
    this.textObj.setPosition(
      this.overlay.x + (this.overlay.width - this.textObj.width) / 2,
      (this.overlay.height - this.textObj.height) / 2
    );
    this.updateText("");
  }
  reposition() {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    const visitedTableGameIndex = this.scene.getVisitedTableGameIndex();
    if (visitedTableGameIndex !== -1)
      this.overlay.setX(visitedTableGameIndex * this.overlay.width);
    else this.overlay.setPosition(0, 0);
    this.textObj.setPosition(
      this.overlay.x + (this.overlay.width - this.textObj.width) / 2,
      (this.overlay.height - this.textObj.height) / 2
    );
  }
}
